import React from 'react';
import styled from 'styled-components';

import { Dialog, DialogContent } from '@mui/material';
import { DocsSearch } from './DocsSearch';

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 600px;
    max-width: 90vw;
    margin: 16px;
    position: fixed;
    top: 60px;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border: none;
    overflow: visible;
  }

  .MuiDialogContent-root {
    padding: 8px;
    border-radius: 8px;
    background: ${({ theme }) => theme.background.standard};

    .MuiAutocomplete-popper {
      margin-top: 4px;
    }
  }
`;

interface Props {
  open: boolean;
  onClose: () => void;
}

export const SearchModal: React.FC<Props> = ({ open, onClose }) => {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth='md' fullWidth={false} PaperProps={{ elevation: 8 }}>
      <DialogContent>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <DocsSearch isModal onClose={onClose} autoFocus />
      </DialogContent>
    </StyledDialog>
  );
};
